<template>
  <v-container>
    <v-row>
      <v-text-field
        v-model="Search"
        label="Filter by Name"
        outlined
      ></v-text-field>
      <v-dialog
        v-model="dialog"
        max-width="600"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on">
            <v-icon dark>mdi-key-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>New Inventory Item</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="AddInventory()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="NewItem" class="pa-4">
            <v-row>
              <v-col col="12" md="5">
                <v-text-field
                  v-model="newItem.Name"
                  label="Name"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col col="12" md="3">
                <v-select
                  v-model="newItem.Type"
                  :items="types"
                  label="Type"
                  hide-details
                  outlined
                  single-line
                  required
                ></v-select>
              </v-col>
              <v-col col="12" md="2">
                <v-text-field
                  v-model="newItem.Price"
                  label="Price"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col col="12" md="2">
                <v-text-field
                  v-model="newItem.Qty"
                  label="Qty"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-textarea
                  rows="2"
                  v-model="newItem.Description"
                  label="Description"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-text-field
                  v-model="newItem.Url"
                  label="Url"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="showedit"
        max-width="600"
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="showedit = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>New Inventory Item</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="UpdateItem()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="NewItem" class="pa-4">
            <v-row>
              <v-col col="12" md="5">
                <v-text-field
                  v-model="tempItem.Name"
                  label="Name"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col col="12" md="3">
                <v-select
                  v-model="tempItem.Type"
                  :items="types"
                  label="Type"
                  hide-details
                  outlined
                  single-line
                ></v-select>
              </v-col>
              <v-col col="12" md="2">
                <v-text-field
                  v-model="tempItem.Price"
                  label="Price"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col col="12" md="2">
                <v-text-field
                  v-model="tempItem.Qty"
                  label="Qty"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-textarea
                  rows="2"
                  v-model="tempItem.Description"
                  label="Description"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-text-field
                  v-model="tempItem.Url"
                  label="Url"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" v-if="filteredWeapons.length != 0">
        <v-card>
          <v-card-text class="text-center primary--text pb-0 headline"
            >Weapons</v-card-text
          >
          <v-card-subtitle class="text-center py-2">
            <v-row>
              <v-col cols="4" class="py-0 secondary--text">Name</v-col>
              <v-col cols="4" class="py-0 secondary--text">Description</v-col>
              <v-col cols="2" class="py-0 secondary--text">Qty</v-col>
              <v-col cols="2" class="py-0 secondary--text">Price</v-col>
            </v-row>
          </v-card-subtitle>
          <v-hover v-for="(item, index) in filteredWeapons" :key="index">
            <template v-slot:default="{ hover }">
              <v-card flat>
                <v-card-subtitle class="text-center py-2">
                  <v-row>
                    <v-col cols="4" class="py-0">{{ item.Name }}</v-col>
                    <v-col cols="4" class="py-0">{{ item.Description }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Qty }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Price }}</v-col>
                  </v-row>
                </v-card-subtitle>
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn @click="EditItem(item)" class="primary">Edit</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="filteredArmors.length != 0">
        <v-card>
          <v-card-text class="text-center primary--text pb-0 headline"
            >Armors</v-card-text
          >
          <v-card-subtitle class="text-center py-2">
            <v-row>
              <v-col cols="4" class="py-0 secondary--text">Name</v-col>
              <v-col cols="4" class="py-0 secondary--text">Description</v-col>
              <v-col cols="2" class="py-0 secondary--text">Qty</v-col>
              <v-col cols="2" class="py-0 secondary--text">Price</v-col>
            </v-row>
          </v-card-subtitle>
          <v-hover v-for="(item, index) in filteredArmors" :key="index">
            <template v-slot:default="{ hover }">
              <v-card flat>
                <v-card-subtitle class="text-center py-2">
                  <v-row>
                    <v-col cols="4" class="py-0">{{ item.Name }}</v-col>
                    <v-col cols="4" class="py-0">{{ item.Description }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Qty }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Price }}</v-col>
                  </v-row>
                </v-card-subtitle>
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn @click="EditItem(item)" class="primary">Edit</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" v-if="filteredConsumables.length != 0">
        <v-card>
          <v-card-text class="text-center primary--text pb-0 headline"
            >Consumables</v-card-text
          >
          <v-card-subtitle class="text-center py-2">
            <v-row>
              <v-col cols="4" class="py-0 secondary--text">Name</v-col>
              <v-col cols="4" class="py-0 secondary--text">Description</v-col>
              <v-col cols="2" class="py-0 secondary--text">Qty</v-col>
              <v-col cols="2" class="py-0 secondary--text">Price</v-col>
            </v-row>
          </v-card-subtitle>
          <v-hover v-for="(item, index) in filteredConsumables" :key="index">
            <template v-slot:default="{ hover }">
              <v-card flat>
                <v-card-subtitle class="text-center py-2">
                  <v-row>
                    <v-col cols="4" class="py-0">{{ item.Name }}</v-col>
                    <v-col cols="4" class="py-0">{{ item.Description }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Qty }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Price }}</v-col>
                  </v-row>
                </v-card-subtitle>
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn @click="EditItem(item)" class="primary">Edit</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="filteredMis.length != 0">
        <v-card>
          <v-card-text class="text-center primary--text pb-0 headline"
            >Mis</v-card-text
          >
          <v-card-subtitle class="text-center py-2">
            <v-row>
              <v-col cols="4" class="py-0 secondary--text">Name</v-col>
              <v-col cols="4" class="py-0 secondary--text">Description</v-col>
              <v-col cols="2" class="py-0 secondary--text">Qty</v-col>
              <v-col cols="2" class="py-0 secondary--text">Price</v-col>
            </v-row>
          </v-card-subtitle>
          <v-hover v-for="(item, index) in filteredMis" :key="index">
            <template v-slot:default="{ hover }">
              <v-card flat>
                <v-card-subtitle class="text-center py-2">
                  <v-row>
                    <v-col cols="4" class="py-0">{{ item.Name }}</v-col>
                    <v-col cols="4" class="py-0">{{ item.Description }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Qty }}</v-col>
                    <v-col cols="2" class="py-0">{{ item.Price }}</v-col>
                  </v-row>
                </v-card-subtitle>
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute color="#036358">
                    <v-btn @click="EditItem(item)" class="primary">Edit</v-btn>
                  </v-overlay>
                </v-fade-transition>
              </v-card>
            </template>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import db from "@/fb";
import { store } from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Towns",
  data: () => ({
    types: ["Weapon", "Armor", "Consumable", "Mis"],
    newItem: {},
    dialog: false,
    Search: "",
    campaign: { MasterInventory: [] },
    tempIndex: null,
    tempItem: {},
    showedit: false,
  }),
  components: {},
  methods: {
    AddInventory() {
      if (this.newItem.Type === undefined) {
        this.newItem.Type = "Mis";
      }

      if (this.campaign.MasterInventory) {
        this.campaign.MasterInventory.push(this.newItem);
      } else {
        this.campaign.MasterInventory = [this.newItem];
      }

      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ MasterInventory: this.campaign.MasterInventory });

      this.newItem = {};
      this.dialog = false;
    },
    EditItem(item) {
      this.tempItem = this.campaign.MasterInventory.find((i) => i === item);
      this.tempIndex = this.campaign.MasterInventory.findIndex(
        (i) => i === item
      );
      this.showedit = true;
    },
    UpdateItem() {
      db.collection("campaigns")
        .doc(store.CurrentCampaign.id)
        .update({ MasterInventory: this.campaign.MasterInventory });
      this.showedit = false;
    },
  },
  computed: {
    filteredItems: function() {
      return this.campaign.MasterInventory.filter((item) => {
        if (typeof item.Name === "undefined") {
          item.Name = "";
        }
        return item.Name.toLowerCase().match(this.Search.toLowerCase());
      });
    },
    filteredWeapons: function() {
      return this.filteredItems.filter((item) => {
        return item.Type.match("Weapon");
      });
    },
    filteredArmors: function() {
      return this.filteredItems.filter((item) => {
        return item.Type.match("Armor");
      });
    },
    filteredConsumables: function() {
      return this.filteredItems.filter((item) => {
        return item.Type.match("Consumable");
      });
    },
    filteredMis: function() {
      return this.filteredItems.filter((item) => {
        return item.Type.match("Mis");
      });
    },
  },

  firestore() {
    this.$bind(
      "campaign",
      db.collection("campaigns").doc(store.CurrentCampaign.id)
    );
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>
